import { VisuallyHidden } from "@react-aria/visually-hidden";
import { Input } from "@nju/form";
import { Icon } from "@nju/icons";
import { Button } from "@nju/ui";

interface ISearchProps {
  setSearchValue: (value: string) => void;
  clearSearch: () => void;
  searchValue: string;
}

export function Search({
  clearSearch,
  setSearchValue,
  searchValue,
}: ISearchProps) {
  return (
    <>
      <Input
        aria-label="W czym możemy Ci pomóc?"
        label="W czym możemy Ci pomóc?"
        name="searchPhrase"
        onValueChange={setSearchValue}
        suffix={
          searchValue ? (
            <>
              <Button onPress={clearSearch} size="inline" variant="simple">
                <Icon name="times" />
                <VisuallyHidden elementType="span">
                  przycisk do czyszczenia zawartości wyszukiwarki
                </VisuallyHidden>
              </Button>
            </>
          ) : (
            <Icon name="search" />
          )
        }
        value={searchValue}
      />
      <VisuallyHidden>wyszukiwarka po frazie</VisuallyHidden>
    </>
  );
}
